import axios from 'axios';

// 创建 axios 实例
const service = axios.create({
  baseURL: '/api', // 对应 Nginx 反向代理路径
  timeout: 5000
});

// 请求拦截器：携带登录 token
service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = token;
    }
    return config;
  },
  error => Promise.reject(error)
);

// 响应拦截器：统一处理结果
service.interceptors.response.use(
  response => response.data,
  error => {
    alert('接口请求失败：' + (error.message || '网络错误'));
    return Promise.reject(error);
  }
);

export default service;